module.exports = "<div class=\"login_inner\">\n  <img ng-src=\"{{$ctrl.logoSrc}}\" alt=\"logo\" class=\"login_logo\" />\n  <div class=\"login_orange-dash\"></div>\n  <div class=\"login__subtitle\">\n    Log in to your account\n  </div>\n  <login-form class=\"login-form\" on-login=\"$ctrl.onLogin()\"></login-form>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/screens/login/login.html
// module id = 373
// module chunks = 0